// i18n area 'common' — locale lt-LT (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.lt-LT.meta.json.
import type { enUS } from './common'

export const ltLT: typeof enUS = {
  nav: {
    home: 'Pradžia',
    vms: 'Virtualiosios mašinos',
    templates: 'Template',
    importVms: 'Importuoti VM',
    containers: 'Konteineriai',
    containersApps: 'Programos',
    containersPods: 'Podai',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI atvaizdžiai',
    containersOciRegistries: 'OCI registry',
    containersCtTemplates: 'CT template',
    networkServices: 'Tinklo paslaugos',
    firewall: 'Užkarda',
    checkpoints: 'Checkpoint',
    backup: 'Backup',
    monitoring: 'Stebėsena',
    cluster: 'Klasteris',
    clusterSettings: 'Visuotiniai nustatymai',
    clusterNodes: 'Mazgai',
    clusterDevices: 'USB ir PCIe ištekliai',
    clusterFederation: 'Federacija',
    network: 'Tinklas',
    overlayNetworks: 'Overlay tinklai',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Duomenys',
    storages: 'Storage',
    hci: 'Hiperkonvergencija',
    ceph: 'Ceph',
    system: 'Sistema',
    tasks: 'Task',
    events: 'Įvykiai',
    audit: 'Auditas',
    diagnostics: 'Diagnostika',
    notifications: 'Pranešimai',
    proximity: 'TVirt Proximity',
    users: 'Naudotojai ir grupės',
    groups: 'Grupės',
    mfa: 'MFA',
    realms: 'Realm ir SSO',
    rbac: 'Rolės ir teisės',
    credentials: 'Prisijungimo duomenys',
    scopes: 'Scope',
    tags: 'Žymos',
    explorer: 'Naršyti',
    licensing: 'Licencija',
    information: 'Informacija'
  },
  mode: {
    light: 'Šviesi',
    dark: 'Tamsi',
    system: 'Sistemos',
    tooltip: 'Tema'
  },
  language: {
    tooltip: 'Kalba'
  },
  langRegion: {
    europe: 'Europa',
    northAmerica: 'Šiaurės Amerika',
    southAmerica: 'Pietų Amerika',
    asia: 'Azija'
  },
  notFound: {
    title: 'Puslapis nerastas',
    body: 'Šis adresas neatitinka jokio TVirt puslapio — jis galėjo pasikeisti po atnaujinimo arba nuoroda yra sena.',
    backHome: 'Grįžti į pradžią'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'Visas klasteris',
    noChildren: 'Čia nėra antrinių scope',
    recursive: 'Įtraukti žemesnio lygio',
    collapse: 'Suskleisti scope skydelį',
    openPicker: 'Naršyti scope',
    up: 'Kilti lygiu aukščiau',
    countTooltip: '{direct} šiame scope · {total} įskaitant žemesnio lygio'
  },
  search: {
    tooltip: 'Ieškoti (⌘K)',
    placeholder: 'Ieškoti VM, tinklų, storage…',
    empty: 'Rezultatų nėra',
    groups: {
      recent: 'Paskutiniai',
      shortcuts: 'Nuorodos',
      actions: 'Veiksmai',
      goTo: 'Eiti į'
    },
    kind: {
      catalog: 'Katalogas',
      scope: 'Scope',
      node: 'Mazgas'
    },
    footer: {
      navigate: 'naršyti',
      open: 'atverti',
      close: 'uždaryti'
    },
    actions: {
      createVm: 'Sukurti VM…',
      uploadIso: 'Įkelti ISO…',
      clusterSettings: 'Klasterio nustatymai',
      consoleOf: 'Eiti į {name} konsolę'
    }
  },
  stub: {
    containersSummary: 'Programos ir sistemos konteineriai (CT) su savo OCI atvaizdžiais, registry ir template — valdomi šalia jūsų VM.',
    sectionSummary_vms: 'Virtualiosios mašinos ir jų template — gyvavimo ciklas, snapshot, migravimas ir konsolė.',
    sectionSummary_storages: 'Storage, kuriuose gyvena VM diskai, atvaizdžiai ir metaduomenys.',
    sectionSummary_catalogs: 'Klasterio failinių artefaktų namai: ISO atvaizdžiai, CT ir VM template bei OCI archyvai, sudėti į katalogus.',
    sectionSummary_overlay: 'VXLAN overlay tinklai tarp klasterio mazgų.',
    sectionSummary_fabric: 'Fizinio tinklo inventorius — switch, prievadai, LAGG ir loginiai tinklai.',
    sectionSummary_ipam: 'Adresacija, išvesta iš fabric ir overlay tinklų: kas laiko kiekvieną adresą.',
    sectionSummary_services: 'DHCP ir DNS serveriai, išvesti iš tinklo registro.',
    sectionSummary_ceph: 'Ceph klasteriai, valdomi TVirt mazguose.',
    sectionSummary_hci: 'Hiperkonvergentinės storage technologijos TVirt mazguose.',
    sectionSummary_cluster: 'Mazgai, narystė ir klasterio nustatymai.',
    containers: 'Sistemos konteineriai yra planuose — jie atsiras šiame skyriuje.',
    containersApps: 'Konteinerizuotos programos yra planuose — jos atsiras šioje srityje.',
    containersPods: 'Podai sujungia konteinerius, kurie dalijasi tinklu ir tomais — egzemplioriai yra programos.',
    containersCt: 'Sistemos konteineriai (CT) yra planuose — jie atsiras šioje srityje.',
    multiscsi: 'TVStor MultiSCSI yra planuose — jis atsiras šioje srityje.',
    clusterFederation: 'TVirt klasterių federacija yra planuose — ji atsiras šioje srityje.',
    containersOciImages: 'OCI atvaizdžiai yra planuose — jie atsiras šioje srityje.',
    containersOciRegistries: 'OCI registry yra planuose — jie atsiras šioje srityje.',
    containersCtTemplates: 'CT template yra planuose — jie atsiras šioje srityje.',
    importVms: 'ESXi ir Proxmox importavimo įrankiai atsiras čia: svečių sistemų konvertavimas ir masinis perkėlimas į TVirt.',
    backup: 'Integruotas backup ateina su 6.2 versija: dedublikuotos content-addressed saugyklos, CBT prieaugiai, nekintamumo langai ir replikacija iš saugyklos į saugyklą.',
    monitoring: 'Viso klasterio išteklių konkurencijos suvestinės (cpu.ready, PSI spaudimas, integruoti įspėjimai) jau kelyje — šiandien tos pačios metrikos gyvena kiekvienos VM detalėse.'
  },
  home: {
    welcome: 'Prisijungėte su paskyra: {name}',
    subtitle: 'Štai jūsų TVirt klasteris vienu žvilgsniu.',
    loadError: 'Nepavyko įkelti apžvalgos — ar TVirt backend pasiekiamas?',
    health: {
      ok: 'Viskas tvarkoje',
      warning: 'Dėmesio',
      critical: 'Kritinės problemos'
    },
    reason: {
      'node-down': '{subject} išjungtas',
      'node-stale': '{subject} jau kurį laiką neatsiliepia',
      'node-maintenance': '{subject} priežiūros režimu',
      'tasks-failed': {
        one: '{n} nepavykęs task per pastarąsias 24 val.',
        few: '{n} nepavykę task per pastarąsias 24 val.',
        many: '{n} nepavykusio task per pastarąsias 24 val.',
        other: '{n} nepavykusių task per pastarąsias 24 val.'
      },
      'storage-degraded': 'storage {subject} degradavęs',
      'storage-error': 'storage {subject} klaidos būsenoje',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'klasterio store nepasiekiamas',
      'license-absent': 'licencijos nėra — naujų VM paleisti negalima',
      'license-expired': 'licencija baigėsi — naujų VM paleisti negalima',
      'license-exceeded': 'viršyta licencijos riba — naujų VM paleisti negalima',
      'failover-reserve-eroded': 'failover rezervas beveik išnaudotas',
      'failover-reserve-exhausted': 'failover rezervas išsemtas — naujų VM paleisti negalima',

      'oci-cache-nearly-full': 'OCI podėlis {subject} beveik pilnas — digestai šalinami rankomis',
      'oci-cache-full': 'OCI podėlis {subject} pilnas — nė vienas pull nepavyks, kol digestai nebus pašalinti',
      'config-replica-empty': 'konfigūracijos replika mazge {subject} TUŠČIA — mazgas neturi klasterio konfigūracijos, kol nepavyksta replikacija',
      'config-replica-stalled': 'konfigūracijos replikacija mazge {subject} sustojusi — vietinė kopija atsilieka nuo klasterio konfigūracijos'
    },
    staleChip: 'Duomenys pasenę',
    staleAsOf: 'paskutinė replika {time}',
    zone: {
      nodes: 'Mazgai',
      failoverReserve: 'Failover rezervas',
      capacity: 'Talpa',
      workload: 'Darbo krūvis',
      protection: 'Apsauga',
      activity: 'Naujausia veikla'
    },

    // Failover rezervo zona (N+1 priėmimo kontrolė, task #133b).
    reserve: {
      state: {
        ok: 'Rezervas nepažeistas',
        eroded: 'Rezervas beveik išnaudotas',
        exhausted: 'Rezervas išsemtas',
        unknown: 'Rezervas nežinomas'
      },
      tolerate: {
        one: 'toleruoja {n} mazgo praradimą',
        few: 'toleruoja {n} mazgų praradimą',
        many: 'toleruoja {n} mazgo praradimą',
        other: 'toleruoja {n} mazgų praradimą'
      },
      usedOf: 'naudojama {used} / {allowed} GiB',
      keepFree: 'failover atvejui laisva laikoma {n} GiB',
      expendable: 'iš jų {n} paaukojami veikiant',
      headroom: 'dar galima paleisti {n} GiB',
      short: 'rezervui trūksta {n} GiB — naujų VM paleisti negalima',
      hp: {
        usedOf: '{size} puslapiai — naudojama: {used} / {allowed}',
        keepFree: 'failover atvejui laikomi laisvi: {keep}',
        headroom: 'dar galima paleisti: {n}',
        short: 'rezervui trūksta: {n} — naujų VM su milžiniškais puslapiais paleisti negalima'
      },
      worstCase: 'blogiausias atvejis: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Nė vienas mazgas dar nedeklaravo atminties — rezervo apskaičiuoti neįmanoma ir joks paleidimas neatmetamas.',
      reason: {
        attestedDown: 'patvirtinta, kad išjungtas',
        maintenance: 'priežiūros režimu',
        unreachable: 'nepasiekiamas',
        capacityUnknown: 'atmintis nedeklaruota'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} branduolių / {threads} gijų',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} aktyvi VM',
        few: '{n} aktyvios VM',
        many: '{n} aktyvios VM',
        other: '{n} aktyvių VM'
      },
      activeVmsUnknown: 'aktyvių VM nežinoma',
      lastSeen: 'matytas {time}',
      neverSeen: 'niekada nematytas',
      down: 'Išjungtas',
      maintenance: 'Priežiūra',
      stale: 'Nepasiekiamas'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: 'paskirstyta {n} GiB',
      reserve: 'rezervas {n} GiB',
      unobserved: 'talpa dar nestebėta',
      empty: 'Storage dar nėra'
    },
    workload: {
      vms: 'Virtualiosios mašinos',
      apps: 'Programos',
      services: 'Tinklo paslaugos',
      empty: 'Kol kas nieko',
      phasesUnknown: 'pasiskirstymas pagal fazes neprieinamas'
    },
    protection: {
      none: 'Nesukonfigūruota nė viena atsarginių kopijų paskirties vieta — apsaugokite savo konfigūraciją.',
      configure: 'Konfigūruoti checkpoint',
      noRuns: 'Nė vienas checkpoint dar nesukurtas.',
      last: 'Paskutinis checkpoint',
      onTarget: 'į {target}',
      viewAll: 'Checkpoint'
    },
    activity: {
      empty: 'Naujausios veiklos nėra',
      failed24: {
        one: '{n} nepavykęs per 24 val.',
        few: '{n} nepavykę per 24 val.',
        many: '{n} nepavykusio per 24 val.',
        other: '{n} nepavykusių per 24 val.'
      },
      viewAll: 'Peržiūrėti visus task'
    }
  },
  notes: {
    title: 'Pastabos',
    tabEdit: 'Redaguoti',
    tabPreview: 'Peržiūra',
    placeholder: 'Laisvos operatoriaus pastabos — Markdown atvaizduojamas peržiūroje',
    empty: 'Pastabų nėra',
    tooLarge: 'Pastabos viršija 64 KiB ribą',
    saveError: 'Nepavyko įrašyti pastabų'
  },
  common: {
    contractError: 'Backend atsakyme yra reikšmė, kurios ši sąsaja nepažįsta: {field}={value} — atnaujink žiniatinklio sąsają iki backend versijos.',
    contractErrorItems: '{count} šio sąrašo objektų ši sąsaja negali perskaityti ({field}={value}) ir jie nerodomi.',
    staleHint: 'Store nepasiekiamas — tai šio mazgo konfigūracijos replika; viso parko būsena nežinoma.',
    staleStateAge: 'būsena {time}',
    staleStateNever: 'būsena niekada negauta iš store: matote tik šio mazgo stebėjimus',
    staleStateTooltip: 'Klasterio store nepasiekiamas: stebima būsena (fazė, mazgas, agentas) gaunama iš šio mazgo būsenos replikos ir atitinka paskutinį sėkmingą skaitymą iš store — ji gali būti pasenusi.',
    noPermission: 'Neturite teisių šiam veiksmui',
    actionStillRunning: 'Veiksmas vis dar vykdomas — rezultatas dar nežinomas',
    staleWrite: 'Kažkas kitas pakeitė šį objektą, kol jį redagavote — nieko neįrašyta. Įkelkite iš naujo ir pakartokite pakeitimą naujausioje būsenoje.',
    staleReload: 'Įkelti iš naujo',
    preview: 'Peržiūra',
    previewTitle: 'Rezultato peržiūra',
    previewNothingWritten: 'Imituota serveryje — nieko neįrašyta.',
    previewChanged: 'Paryškintos reikšmės, kurios pasikeistų.'
  },
  context: {
    copySelection: 'Kopijuoti pažymėtą tekstą'
  },
  crud: {
    create: 'Kurti',
    viewDetails: 'Peržiūrėti detales',
    viewOrEdit: 'Peržiūrėti arba redaguoti',
    selected: 'pažymėta',
    viewUsingVms: 'Peržiūrėti šį išteklių naudojančias VM',
    clearSelection: 'Atžymėti',
    deleteSelected: 'Ištrinti pažymėtus',
    bulkConfirmBody: {
      one: 'Ištrinti {count} pažymėtą elementą? Apsaugotasis bus nurodytas ir paliktas.',
      few: 'Ištrinti {count} pažymėtus elementus? Apsaugotieji bus nurodyti ir palikti.',
      many: 'Ištrinti {count} pažymėto elemento? Apsaugotieji bus nurodyti ir palikti.',
      other: 'Ištrinti {count} pažymėtų elementų? Apsaugotieji bus nurodyti ir palikti.'
    },
    bulkDeleted: 'ištrinta',
    bulkRefused: 'atmesta',
    fieldId: 'ID',
    createdAt: 'Sukurta',
    updatedAt: 'Atnaujinta',
    immutableField: 'Nustatyta kuriant — contract neleidžia to keisti',
    immutableScope: 'Scope priskiriamas kuriant; kai kurie ištekliai perkeliami atskiru veiksmu',
    observedField: 'Stebima būsena — pateikia platforma, redaguoti negalima'
  }
}
